import React from 'react';
import { useTranslation } from 'react-i18next';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import SectionWrapper from 'pages/Layout/SectionWrapper';
import NavigationLink from 'components/links/NavigationLink';
import Input from 'components/inputs/Input';
import Button from 'components/buttons/Button';
import { SectionForm, InputWrapper, ButtonStyled } from '../../Styled';
import Spinner from 'components/Spinner/Spinner';

import DropdownSearchable from 'components/inputs/DropdownSearchable';
import { AgentData } from 'services/rest/SuperAdmin/Agents/createAgent';

export interface CreateAgentFormProps {
  onSubmit: (event: React.FormEvent) => void;
  errors: FieldErrors<AgentData>;
  register: UseFormMethods['register'];
  setValue: any;
  control: any;
  loader: boolean;
  companies: any;
  selectedCompanies: any;
  setSelectedCompanies: any;
  setErrors: any;
}

const CreateAgentForm: React.FC<CreateAgentFormProps> = props => {
  const {
    onSubmit,
    errors,
    register,
    loader,
    companies,
    selectedCompanies,
    setSelectedCompanies,
    setValue,
    setErrors
  } = props;
  const { t } = useTranslation(['super_admin_agent']);

  const options = companies?.map((company: any) => ({
    value: company.id,
    label: company.name
  }));

  return (
    <SectionWrapper>
      <NavigationLink
        text={t('super_admin_agent:form:back')}
        direction="back"
        to={'/agents'}
      />
      <h1>{t('super_admin_agent:create_agent')}</h1>
      <form onSubmit={onSubmit}>
        <SectionForm>
          <InputWrapper>
            <label>{t('super_admin_agent:form:name')}</label>
            <div className="w-100">
              <Input
                name="name"
                type="text"
                placeholder={t('super_admin_agent:form:name')}
                ref={register}
                error={errors.name?.message}
              />
            </div>
          </InputWrapper>
          <InputWrapper>
            <label>{t('super_admin_agent:form:lastName')}</label>
            <div className="w-100">
              <Input
                name="lastName"
                type="text"
                placeholder={t('super_admin_agent:form:lastName')}
                ref={register}
                error={errors.name?.message}
              />
            </div>
          </InputWrapper>
          <InputWrapper>
            <label>{t('super_admin_agent:form:email')}</label>
            <div className="w-100">
              <Input
                name="email"
                type="text"
                placeholder={t('super_admin_agent:form:email')}
                ref={register}
                error={errors.email?.message}
              />
            </div>
          </InputWrapper>

          <InputWrapper>
            <label>{t('super_admin_agent:form:company')}</label>
            <div className="w-100">
              <DropdownSearchable
                name="companyIds"
                isSearchable
                isMulti={true}
                placeHolder="Seleccione compañías"
                options={options}
                onChange={selectedValue => {
                  let optionsArray: any[] = [];

                  if (selectedValue) {
                    optionsArray = Array.isArray(selectedValue)
                      ? selectedValue
                      : [selectedValue];
                  }

                  const companyIds = optionsArray.map(option => option.value);
                  setSelectedCompanies(optionsArray);
                  setValue('companyIds', companyIds);
                  setErrors('companyIds', '');
                }}
              />
            </div>
          </InputWrapper>
        </SectionForm>
        <ButtonStyled>
          {!loader ? (
            <Button
              value={t('super_admin_agent:create_agent')}
              variant="primary"
            />
          ) : (
            <Spinner name="sign-up" />
          )}
        </ButtonStyled>
      </form>
    </SectionWrapper>
  );
};

export default CreateAgentForm;
